import { useState } from 'react';
import LoadingPage from '../../components/LoadingPage';
import PageHeader from '../../components/PageHeader';
import './AmlCheckProgress.scss';

const AmlCheckProgress = () => {
	const [loading, setLoading] = useState(true);

	return <div className='AmlCheckProgress'>{loading ? <LoadingPage /> : <PageHeader />}</div>;
};

export default AmlCheckProgress;
